<div class="kt-portlet">
    <div class="kt-portlet__head  d-flex align-items-center justify-content-between">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Yeni Personel
            </h3>
        </div>
        <button type="button" routerLink="/users" class="btn btn-secondary mr-3">Geri Dön</button>
    </div>
    <div class="container" style="width: 90%">
        <form class="kt-form kt-form--label-left" autocomplete="off">
            <div class="kt-portlet__body">
                <div class="form-group row">
                    <label for="role" class="col-2 col-form-label">Rol</label>
                    <div class="col-10">
                        <ng-select labelForId="role" [clearable]="false" [items]="roles" name="island"
                            bindLabel="roleName" bindValue="id" [(ngModel)]="user.roleId" placeholder="Rol">
                        </ng-select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="ad" class="col-2 col-form-label">Ad soyad</label>
                    <div class="col-10">
                        <input class="form-control" type="text" id="ad" name="ad" [(ngModel)]="user.displayName">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="email" class="col-2 col-form-label">E-mail</label>
                    <div class="col-10">
                        <input class="form-control" autocomplete="off" type="email" id="email" name="email"
                            [(ngModel)]="user.email">
                    </div>
                </div>
                <div class="form-group row" *ngIf="!user.id">
                    <label for="password" class="col-2 col-form-label">Şifre</label>
                    <div class="col-10">
                        <input class="form-control" autocomplete="off" type="password" id="password" name="password"
                            [(ngModel)]="user.password">
                    </div>
                </div>

            </div>
            <div class="kt-portlet__foot">
                <div class="kt-form__actions">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <button type="button" class="btn btn-success" (click)="save()">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>